import PropTypes from "prop-types";
import React from "react";

import checkIconLeft from "icons/cx/arrow-left-bold.svg";
import checkIconRight from "icons/cx/arrow-right-bold.svg";
import { Icon } from "root/libs/ui-components/src";
import { IntlPropType } from "root/libs/core-libs/src";
import { useOnArrowClick } from "./hooks";
import { Arrow, Line, Root } from "./styled";
/**
 * Renders a separator between re-designed origin and destination sections (part of re-imagine postcodes epic).
 * The separator is rendered on desktop resolutions only and offers an arrow icon to flip the sections (aka "Create import shipment").
 */
export const OriginDestinationSeparator = ({ switchRef, rotate, intl }) => {
  const line = <Line aria-hidden="true" />;
  const isDirRtl = document.querySelector("html")?.dir === "rtl";
  const checkIcon = isDirRtl ? checkIconLeft : checkIconRight;

  return (
    <Root className={`${isDirRtl && "no-margin"}`}>
      {line}
      <Arrow
        type="button"
        onClick={useOnArrowClick(switchRef)}
        aria-label={intl.formatMessage({
          id: "ChangeCountryTextAndLink.changeCountry",
        })}
      >
        <Icon
          className={`arrow-svg ${!rotate && "no-rotate"}`}
          icon={checkIcon}
          useAs="decorative"
          width={{ mobile: "16px", desktop: "30px" }}
        />
      </Arrow>
      {line}
    </Root>
  );
};

OriginDestinationSeparator.propTypes = {
  /**
   * Reference to the toggle checkbox that flips the origin and destination sections.
   */
  switchRef: PropTypes.object.isRequired,
  rotate: PropTypes.bool,
  intl: IntlPropType.isRequired,
};
